import { useState } from "react";

interface CopyButtonProps {
    value: string;
    size?: number;
    className?: string;
}

export default function CopyButton({
    value,
    size = 16,
    className = "",
}: CopyButtonProps) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), 1200);
        } catch (e) {
            console.error("Copy failed", e);
        }
    };

    return (
        <span
            role="button"
            onClick={handleCopy}
            title={copied ? "Copied!" : "Copy"}
            className={`d-inline-flex align-items-center ${className}`}
            style={{ cursor: "pointer" }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 16 16"
                fill="none"
            >
                <path
                    d="M4 7.33334C4 5.44772 4 4.50491 4.58579 3.91912C5.17157 3.33334 6.11438 3.33334 8 3.33334H10C11.8856 3.33334 12.8284 3.33334 13.4142 3.91912C14 4.50491 14 5.44772 14 7.33334V10.6667C14 12.5523 14 13.4951 13.4142 14.0809C12.8284 14.6667 11.8856 14.6667 10 14.6667H8C6.11438 14.6667 5.17157 14.6667 4.58579 14.0809C4 13.4951 4 12.5523 4 10.6667V7.33334Z"
                    stroke={copied ? "#28a745" : "#0069AD"}
                />
                <path
                    d="M4 12.6667C2.89543 12.6667 2 11.7712 2 10.6667V6.66667C2 4.15251 2 2.89543 2.78105 2.11438C3.5621 1.33334 4.81918 1.33334 7.33333 1.33334H10C11.1046 1.33334 12 2.22877 12 3.33334"
                    stroke={copied ? "#28a745" : "#0069AD"}
                />
            </svg>
        </span>
    );
}
